import { createFileRoute } from "@tanstack/react-router";
import { StarlinkOverview } from "./-components/StarlinkOverview";

export const Route = createFileRoute("/_staff/starlinks/_layout/overview/")({
  component: StarlinkOverview,
});
